/** @format */

import React from 'react'
import styled from 'styled-components'
import CodeMirror from 'codemirror'
import { Controlled } from 'react-codemirror2'
import 'codemirror/lib/codemirror.css'
import 'codemirror/theme/material.css'

CodeMirror.defineMode('promql', () => {
  const keywords = [
    'sum',
    'avg',
    'rate',
    'irate',
    'increase',
    'delta',
    'predict_linear',
    'by',
    'without',
    'group_left',
    'group_right',
    'offset',
    'bool',
    'and',
    'or',
    'unless'
  ]
  const functions = ['rate', 'irate', 'increase', 'delta', 'abs', 'absent', 'ceil', 'floor']

  return {
    token: stream => {
      // 跳过空格
      if (stream.eatSpace()) return null

      // 匹配关键字
      for (const keyword of keywords) {
        if (stream.match(keyword)) return 'keyword'
      }

      // 匹配函数
      for (const func of functions) {
        if (stream.match(func + '(')) return 'builtin'
      }

      // 匹配标签选择器（如 `service="api"`）
      if (stream.match(/[a-zA-Z_][a-zA-Z0-9_]*(?==)/)) return 'attribute'

      // 匹配字符串
      if (stream.match(/"[^"]*"/)) return 'string'

      // 匹配数字
      if (stream.match(/[0-9]+/)) return 'number'

      // 匹配操作符
      if (stream.match(/[+\-*/%]/)) return 'operator'

      // 默认跳过
      stream.next()
      return null
    }
  }
})

CodeMirror.defineMIME('text/x-promql', 'promql')
interface PromQLCodemirrorProps {
  className?: string
  value: string
  onChange?: (value: string) => void
  slotBottomRight?: React.ReactNode
}
const PromQLCodemirror: React.FC<PromQLCodemirrorProps> = ({
  className,
  value = '',
  onChange,
  slotBottomRight
}) => {
  return (
    <div className={className}>
      <Controlled
        value={value}
        options={{
          mode: 'text/x-promql',
          theme: 'material',
          lineNumbers: true,
          lineWrapping: true,
          foldGutter: true,
          gutters: ['CodeMirror-linenumbers'],
          // 快捷键配置
          extraKeys: {
            Tab: 'indentMore', // Tab 增加缩进
            'Shift-Tab': 'indentLess', // Shift+Tab 减少缩进
            Enter: 'newlineAndIndent' // Enter 换行并缩进
          }
        }}
        onBeforeChange={(editor, data, value) => {
          onChange(value)
        }}
      />
      {slotBottomRight ? <div className="codemirror-bottom-right">{slotBottomRight}</div> : null}
    </div>
  )
}

export default styled(PromQLCodemirror)`
  position: relative;
  .CodeMirror-scroll {
    .CodeMirror-sizer {
      margin-left: 29px !important;
    }
  }
  .codemirror-bottom-right {
    position: absolute;
    right: 8px;
    bottom: 4px;
    z-index: 10;
    pointer-events: auto;
  }
`
